import { useNavigate } from "react-router";

import { CreateAuthOrganizationForm } from "@components/Forms";

import { Card } from "@design-system/Card/Card";

import { routes } from "@pages/routes";

export const CreateAuthOrganizationCard = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate(routes.portal.dashboard.$path(), { viewTransition: true });
  };

  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>Let's get you started</Card.Header.Title>
      </Card.Header>
      <Card.Body>
        <CreateAuthOrganizationForm onSuccess={handleSuccess} />
      </Card.Body>
    </Card>
  );
};
